<template>
    <div class="pretlak">
        <div class="left">
            <div class="left_cont">
                <a href="/" class="back">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.25 7H14.75M6.5 1.75L1.25 7L6.5 1.75ZM1.25 7L6.5 12.25L1.25 7Z" stroke="#F93C34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Prejsť na hlavnú stránku DOFFERO®
                </a>
                <img class="tablet" src="/img/pretlak_left.svg" alt="pretlak">
                <img class="zlava" src="/img/digiuni_zlava.svg" alt="pretlak_zlava">
                <svg class="rect1" width="102" height="81" viewBox="0 0 102 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="102" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
                <svg class="rect2" width="55" height="81" viewBox="0 0 55 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.2" x="-135" width="190" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
                <svg class="rect3" width="102" height="81" viewBox="0 0 102 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="102" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
                <svg class="rect4" width="115" height="81" viewBox="0 0 115 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="115" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
            </div>
        </div>
        <div class="right">
            <svg class="rect1" width="116" height="81" viewBox="0 0 116 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="232" height="81" rx="40.5" fill="#F93C34"/>
            </svg>
            <svg class="rect2" width="71" height="81" viewBox="0 0 71 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="178" height="81" rx="40.5" fill="#F93C34"/>
            </svg>
            <div class="right_cont">
                <div class="p_logo">
                    <a href="#">
                        <img src="/img/welcome/logos/doffero-logo-v2.svg" alt="logo">
                    </a>
                    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="16.3168" y1="0.771389" x2="1.77134" y2="15.3168" stroke="#263544" stroke-width="2.18182"/>
                        <line y1="-1.09091" x2="20.5704" y2="-1.09091" transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.45459 0)" stroke="#263544" stroke-width="2.18182"/>
                    </svg>
                    <a href="https://digitalnauniverzita.sk/" target="_blank">
                        <img src="/img/digiuni.png" width="220" alt="logo" style="margin-bottom: 10px;">
                    </a>
                </div>
                <a href="/" class="back">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.25 7H14.75M6.5 1.75L1.25 7L6.5 1.75ZM1.25 7L6.5 12.25L1.25 7Z" stroke="#F93C34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Prejsť na hlavnú stránku DOFFERO®
                </a>
                <h1>
                    Krásne cenové ponuky <br>
                    <span>so zľavou 15%</span>
                </h1>
                <p class="top_text">
                    <b>Vyklikaj si cenovú ponuku</b>, do ktorej sa klient 
                    zamiluje na prvý pohľad. Stačí jednoduchá
                    registrácia. V spolupráci s digitalna univerzita sme pre teba 
                    pripravili zľavu a balík  <b>PREMIUM ťa vyjde o takmer o 8 eur menej.</b>
                </p>
                <form class="form form--registration" action="/registracia" method="POST">
                    <input type="hidden" name="_token" :value="csrf">
                    <div class="form-group" :class="errors.meno ? 'has-error' : ''">
                        <div class="input-wrapper">
                            <label class="form__label" for="meno">Meno a priezvisko</label>
                            <input v-model="user.meno" class="form__input" type="text" name="meno" id="meno">
                        </div>
                        <div v-show="errors.meno" class="form-error">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                            </svg>
                            {{errors.meno}}
                        </div>
                    </div>
                    <input type="hidden" name="priezvisko" :value="user.priezvisko">
                    <div class="form-group" :class="errors.email ? 'has-error' : ''">
                        <div class="input-wrapper email">
                            <label class="form__label" for="email">Email</label>
                            <input v-model="user.email" class="form__input" type="email" name="email" id="email">
                        </div>
                        <div v-show="errors.email" class="form-error">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                            </svg>
                            {{errors.email}}
                        </div>
                    </div>
                    <div class="form-group form-group--last" :class="errors.password ? 'has-error' : ''">
                        <div class="input-wrapper password">
                            <label class="form__label" for="heslo">Heslo</label>
                            <input 
                                v-model="user.password" 
                                @focus="focus_password = true" 
                                @blur="focus_password = false"
                                class="form__input pass" type="password" name="password" id="heslo">
                            <div class="password-toggle js-password-show">
                                <i class="eye" data-target="#heslo"></i>
                            </div>
                        </div>
                        <div v-if="focus_password" class="password_errors">
                            <span :class="passowrd_errors.znaky ? 'active' : ''">
                                <svg v-if="!passowrd_errors.znaky" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                                </svg>
                                <svg v-if="passowrd_errors.znaky" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                                    <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                8 znakov
                            </span>
                            <span :class="passowrd_errors.letter ? 'active' : ''">
                                <svg v-if="!passowrd_errors.letter" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                                </svg>
                                <svg v-if="passowrd_errors.letter" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                                    <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                1 veľké písmeno
                            </span>
                            <span :class="passowrd_errors.number ? 'active' : ''">
                                <svg v-if="!passowrd_errors.number" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                                </svg>
                                <svg v-if="passowrd_errors.number" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                                    <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                1 číslica
                            </span>
                        </div>
                        <div v-show="errors.password" class="form-error">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                            </svg>
                            {{errors.password}}
                        </div>
                    </div>              
                    <div class="form-group">
                        <div class="input-wrapper email">
                            <label class="form__label is-jumped" for="email">Zľavový kod</label>
                            <input v-model="user.kod" class="form__input" type="text" name="kod" id="kod">
                        </div>
                    </div>  
                    <div class="form-helper">
                        <input v-model="user.suhlas" class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                        <p @click="user.suhlas = !user.suhlas">Súhlasím so 
                            <a target="_blank" href="https://www.doffero.com/DOFFERO_zmluva_registracia.pdf">
                            spracovaním osobných údajov</a>
                        </p>
                    </div>
                    <div v-show="errors.suhlas" class="form-error">
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                        </svg>
                        {{errors.suhlas}}
                    </div>
                    <div class="form-submit">
                        <button @click="save($event)" class="btn--primary" type="submit" >Vytvoriť účet</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
    export default {
        props: ['email'],
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                user: {
                    meno: null,
                    priezvisko: null,
                    email: null,
                    password: null,
                    password_conf: null,
                    suhlas: false,
                    kod: "DIGIUNI2021"
                },
                errors: {
                    meno: '',
                    email: '',
                    password: '',
                    password_conf: '',
                    suhlas: ''
                },
                focus_password: false,
                passowrd_errors: {
                    znaky: false,
                    number: false,
                    letter: false
                },
                emails: []
            }
        },
        created () {
            axios.get("/api/auth/emails").then(response => {
                response.data.forEach(element => {
                    this.emails.push(element.email)
                });
            });
            this.user.email = this.email;
        },
        mounted () {
            if(Cookies.get('test_cookie') == 'true'){
            }else{
                $('.top_pretlak').addClass('cookie');
            }
        },
        methods: {
            check_email(){
                let hlp = 0;
                this.emails.forEach(element => {
                    if(this.user.email == element){
                        hlp = 1
                    }
                });
                return hlp
            },
            error(){
                var hlp = true;
                const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

                if(!this.user.meno){
                    this.errors.meno = 'Meno je potrebný údaj.'
                    hlp = false;
                }else{
                    this.errors.meno = ''
                }

                if(!this.user.email){
                    this.errors.email = 'Email je potrebný údaj.'
                    hlp = false;
                }else if (!emailRegex.test(this.user.email)) {
                    this.errors.email = 'Zadajte spravný format emailu.'
                    hlp = false
                }else if(this.check_email()){
                    this.errors.email = 'Email už existuje.'
                    hlp = false
                }else{
                    this.errors.email = ''
                }
                    
                if(!this.user.password){
                    this.errors.password = 'Heslo je potrebný údaj.'
                    hlp = false;
                }else if(this.user.password.length < 8){
                    this.errors.password = 'Heslo musí obsahovať viac ako 8 znakov.'
                    hlp = false;
                }else{
                    this.errors.password = ''
                }

                if(!this.passowrd_errors.znaky){
                    hlp = false;
                    $('#heslo').focus();
                }
                else if(!this.passowrd_errors.letter){
                    hlp = false;
                    $('#heslo').focus();
                }
                else if(!this.passowrd_errors.number){
                    hlp = false;
                    $('#heslo').focus();
                }

                if(!this.user.suhlas){
                    this.errors.suhlas = 'Treba udeliť súhlas.'
                    hlp = false;
                }else{
                    this.errors.suhlas = ''
                }
      
                return hlp;
            },
            save(event){
                if(!this.error()){
                    event.preventDefault();
                }else{
                    var name = this.user.meno.split(" ")
                    this.user.meno = name[0]
                    this.user.priezvisko = name[1]
                    localStorage.setItem('premium', 'true');
                    this.$gtm.push({ 
                        event: 'registration',
                        'Event category': 'registration',
                        'Event action': 'successfull_registration',
                        'Event label': 'digi'
                    })
                }
                
            }
        },
        watch: {
            'user.email': function() {
                if (this.user.email.length > 0) {
                    $(".input-wrapper.email label").addClass("is-jumped");
                }
            },
            'user.password': function() {
                if(this.focus_password){
                    this.passowrd_errors.znaky = false
                    this.passowrd_errors.number = false
                    this.passowrd_errors.letter = false
                    if((this.user.password).length >= 8){
                        this.passowrd_errors.znaky = true
                    }
                    if(/\d/.test(this.user.password)){
                        this.passowrd_errors.number = true
                    }
                    if(/[A-Z]/.test(this.user.password)){
                        this.passowrd_errors.letter = true
                    }
                    this.errors.password = ''
                }
                if (this.user.password.length > 0) {
                    $(".input-wrapper.password label").addClass("is-jumped");
                }
            }
        },
    }
</script>
<style lang="scss" scoped>
    .password_errors{
        display: flex;
        align-items: center;
        margin-top: 10px;
        span{
            display: flex;
            align-items: flex-start;
            font-size: 14px;
            color: #e83c58;
            margin-right: 20px;
            svg{
                width: 16px;
                height: 13px;
                margin-right: 5px;
            }
        }
        span.active{
            color: #34D399;
        }
    }
    button {
        cursor: pointer;
        color: #fff !important;
    }
    .pretlak{
        display: flex;
        @media only screen and (max-width: 1000px) {
            display: grid;
        }
        .left{
            background: #fff9fb;
            width: 50%;
            padding-left: 100px;
            padding-top: 60px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            @media only screen and (max-width: 1000px) {
                width: 100%;
                order: 2;
                padding: 30px 0 0 0;
            }
            .zlava{
                position: absolute;
                top: 227px;
                right: 18px;
                @media only screen and (max-width: 1000px) {
                    right: 80px;
                }
                @media only screen and (max-width: 500px) {
                    right: 10px;
                    width: 60%;
                    top: 66px;
                }
            }
            .back{
                width: fit-content;
                font-style: normal;
                font-weight: 800;
                font-size: 16px;
                line-height: 20px;
                display: flex;
                align-items: center;
                color: #212541;
                text-decoration: none;
                svg{
                    margin-right: 15px;
                }
                margin-bottom: 60px;
                @media only screen and (max-width: 1200px) {
                    width: 75%;
                    justify-content: center;
                }
                @media only screen and (max-width: 1000px) {
                    display: none;
                }
            }
            img.tablet{
                @media only screen and (max-width: 500px) {
                    width: 100%;
                }
            }
            @media only screen and (max-width: 500px) {
                svg{
                    display: none !important;
                }
            }
            .rect1{
                position: absolute;
                left: 67px;
                bottom: 0;
                top: 0;
                margin: auto;
            }
            .rect2{
                position: absolute;
                left: 0;
                bottom: 0;
                top: 0;
                margin: auto;
            }
            .rect3{
                position: absolute;
                left: 47px;
                bottom: 209px;
                margin: auto;
            }
            .rect4{
                position: absolute;
                right: 67px;
                bottom: 331px;
                margin: auto;
            }
        }
        .right{
            position: relative;
            width: 50%;
            @media only screen and (max-width: 1000px) {
                width: 100%;
                margin-bottom: 20px;
            }
            .rect1{
                position: absolute;
                right: 0;
                bottom: 509px;
                margin: auto;
                @media only screen and (max-width: 1400px) {
                    right: -70px;
                }
            }
            .rect2{
                position: absolute;
                right: 0;
                bottom: 406px;
                margin: auto;
                @media only screen and (max-width: 1400px) {
                    right: -40px;
                }
            }
            .right_cont{
                margin: 0 auto;
                width: 480px;
                @media only screen and (max-width: 1000px) {
                    width: 80%;
                }
                @media only screen and (max-width: 500px) {
                    width: 95%;
                }
                .form-helper{
                    display: flex; 
                    align-items: center;
                    @media only screen and (max-width: 1200px) {
                        padding: 0;
                    }
                    input{    
                        width: 15px;
                        height: 15px;
                        margin-right: 10px;
                        cursor: pointer;
                    }
                    p{
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 20px;
                        color: #ABABAB;
                        margin: 0;
                        cursor: pointer;
                        a{
                            text-decoration: underline;
                            color: #F93C34; 
                        }
                    }
                }
                .p_logo{
                    display: flex;
                    margin-bottom: 90px;
                    justify-content: space-between;
                    align-items: center;
                    width: 450px;
                    //margin-top: 56px;
                    @media only screen and (max-width: 1000px) {
                        margin: 30px auto;
                    }
                    @media only screen and (max-width: 500px) {
                        width: 320px;
                        img{
                            width: 120px;
                        }
                    }
                }
                h1{
                    font-style: normal;
                    font-weight: 800;
                    font-size: 40px;
                    line-height: 54px;
                    color: #212541;
                    span{
                        padding-bottom: 3px;
                        border-bottom: #3455DB 4px solid;
                    }
                    @media only screen and (max-width: 1000px) {
                        text-align: center;
                    }
                    @media only screen and (max-width: 500px) {
                        font-size: 30px;
                        line-height: 40px;
                    }
                }
                .back{
                    width: fit-content;
                    font-style: normal;
                    font-weight: 800;
                    font-size: 16px;
                    line-height: 20px;
                    display: none;
                    align-items: center;
                    color: #212541;
                    text-decoration: none;
                    svg{
                        margin-right: 15px;
                    }
                    margin: 40px auto;
                    @media only screen and (max-width: 1000px) {
                        display: flex;
                    }
                }
                p.top_text{
                    margin: 30px 0 50px 0;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 28px;
                    color: #6B6F8C;
                    @media only screen and (max-width: 1200px) {
                        width: 80%;
                    }
                    @media only screen and (max-width: 1000px) {
                        text-align: center;
                        margin: 30px auto;
                    }
                }
                form{
                    @media only screen and (max-width: 1000px) {
                        margin: 0 auto;
                    }
                }
            }
                
        }
    }
</style>
<style lang="scss">
.graphics-box.graphics-box--02.rellax{
    @media only screen and (max-width: 1000px) {
        display: none !important;
    }
}
</style>